import { createSlice } from "@reduxjs/toolkit";

import constants from "../../utils/constants";
import { scrollTop } from "../../utils/helpers";

const initialState = {
  widgetOpen: true,
  cancelDialogOpen: false,
  infoMessage: {
    open: false,
    type: "error",
    message: "",
    id: 0,
  },
  activeStep: 0,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    closeWidget(state, action) {
      state.cancelDialogOpen = false;

      if (action.payload.reason !== "backdropClick") {
        state.widgetOpen = false;
      }

      if (action.payload.requestType === constants.REQUEST_TYPES.INQUIRY) {
        window.parent.postMessage("closeLitcoBookingWidget", "*");
      } else {
        window.location.href = process.env.REACT_APP_LITCO_SITE;
      }
    },
    updateCancelDialogOpen(state, action) {
      state.cancelDialogOpen = action.payload;
    },
    infoMessage(state, action) {
      state.infoMessage = { ...action.payload, id: state.infoMessage.id + 1 };
    },
    updateActiveStep(state, action) {
      state.activeStep = action.payload;
    },
    previousStep(state) {
      state.activeStep--;
      scrollTop();
    },
    nextStep(state) {
      state.activeStep++;
      scrollTop();
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice.reducer;
